import { useCallback, useState } from 'react';

import { getFormattedTime } from '../utils';
import { useDuration } from '../../../hooks/use-duration';
import { useCurrentTime } from '../../../hooks/use-current-time';
import { Time } from '../../../types/time';
import { useOnCurrentTimeChanged } from '../../../hooks/use-on-current-time-changed';

const REFRESH_DELAY = 250;

export const useFormattedTime = (delay = REFRESH_DELAY) => {
    const duration = useDuration();
    const currentTime = useCurrentTime();
    const [formattedTime, setFormattedTime] = useState<string | null>(() =>
        getFormattedTime(currentTime, duration)
    );

    const onCurrentTimeChange = useCallback(
        (currentTime: Time) => setFormattedTime(getFormattedTime(currentTime, duration)),
        [duration]
    );

    useOnCurrentTimeChanged(onCurrentTimeChange, delay);

    return formattedTime;
};
